/**
 * main.jsx — Application entry point.
 *
 * Order matters:
 * 1. i18n must be initialised before any component renders
 * 2. CSS must be imported before components
 */

// 1. i18n (side-effect import — runs init immediately)
import '@/i18n/i18n'

// 2. Global styles (Tailwind + custom vars)
import '@/index.css'

import React        from 'react'
import ReactDOM     from 'react-dom/client'
import App          from './App'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

